/**
 * Copyright (c) Microsoft Corporation
 * All rights reserved. See License.txt in the project root for license information.
 * IMoeKwrNavigationMenu containerModule Interface Properties
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import * as React from 'react';

export const enum navigationMenuSource {
    all = 'all',
    retailServerOnly = 'retailServerOnly',
    cmsOnly = 'cmsOnly'
}

export interface IMoeKwrNavigationMenuConfig extends Msdyn365.IModuleConfig {
    navigationMenuSource?: navigationMenuSource;
    cmsNavItems?: ICmsNavItemsData[];
    enableMultilevelMenu?: boolean;
    enabletopMenu?: boolean;
    menuLevelSupport?: number;
    rootMenuNavigation?: string;
    displayCategoryImage?: boolean;
    displayPromotionalImage?: boolean;
    categoryPromotionalContent?: ICategoryPromotionalContentData[];
    categoryImageSettings?: Msdyn365.IImageSettings;
    className?: string;
    categoryName?: string;
    categoryDescription?: string;
}

export interface IMoeKwrNavigationMenuResources {
    menuAriaLabel: string;
    backButtonAriaLabel: string;
    allCategoryMenuText: string;
    languageText: string;
    languageTextInMaori: string;
    atuaTabName: string;
    atuaTabNameInMaori: string;
    engageTabName: string;
    engageTabNameInMaori: string;
    curriculaTabName: string;
    curriculaTabNameInMaori: string;
    searchTabName: string;
    searchTabNameInMaori: string;
    closeText: string;
    closeTextInMaori: string;
    introSearchText1: string;
    introSearchText1InMaori: string;
    introSearchText2: string;
    introSearchText2InMaori: string;
    trySearchText: string;
    trySearchTextInMaori: string;
    introAtuaSearchText: string;
    introAtuaSearchTextInMaori: string;
    introAtuaBlurbTextRanguini: string;
    introAtuaBlurbTextRanguiniInMaori: string;
    introAtuaBlurbTextPapatuanuku: string;
    introAtuaBlurbTextPapatuanukuInMaori: string;
    introAtuaBlurbTextTangaroa: string;
    introAtuaBlurbTextTangaroaInMaori: string;
    introAtuaBlurbTextTane: string;
    introAtuaBlurbTextTaneInMaori: string;
    introAtuaBlurbTextTumatauenga: string;
    introAtuaBlurbTextTumatauengaInMaori: string;
    introAtuaBlurbTextRongo: string;
    introAtuaBlurbTextRongoInMaori: string;
    introAtuaBlurbTextHaumia: string;
    introAtuaBlurbTextHaumiaInMaori: string;
    introAtuaBlurbTextTawhirimatea: string;
    introAtuaBlurbTextTawhirimateaInMaori: string;
    introAtuaBlurbTextHineahuone: string;
    introAtuaBlurbTextHineahuoneInMaori: string;
    introAtuaBlurbTextWhiro: string;
    introAtuaBlurbTextWhiroInMaori: string;
    introAtuaBlurbTextRuaumoko: string;
    introAtuaBlurbTextRuaumokoInMaori: string;
    backButtonText: string;
    backButtonTextInMaori: string;
    curatedCollections: string;
    curatedCollectionsInMaori: string;
    newsEvents: string;
    newsEventsInMaori: string;
}

export interface ICmsNavItemsData {
    linkText?: string;
    linkUrl?: Msdyn365.ILinkData;
    image?: Msdyn365.IImageData;
    imageLink?: Msdyn365.ILinkData;
    ariaLabel?: string;
    openInNewTab?: boolean;
    subMenus?: ISubMenusData[];
}

export interface ICategoryPromotionalContentData {
    categoryName?: string;
    image: Msdyn365.IImageData;
    text?: string;
    linkUrl: Msdyn365.ILinkData;
}

export interface ISubMenusData {
    linkText?: string;
    linkUrl: Msdyn365.ILinkData;
    ariaLabel?: string;
    image?: Msdyn365.IImageData;
    imageLink?: Msdyn365.ILinkData;
    subMenus?: ISubMenusData[];
}

export interface ISubMenusData {
    linkText?: string;
    linkUrl: Msdyn365.ILinkData;
    ariaLabel?: string;
    image?: Msdyn365.IImageData;
    imageLink?: Msdyn365.ILinkData;
}

export interface IMoeKwrNavigationMenuProps<T> extends Msdyn365.IModule<T> {
    resources: IMoeKwrNavigationMenuResources;
    config: IMoeKwrNavigationMenuConfig;
    slots: {
        breadcrumb: React.ReactNode[];
    };
}
